// Sync commit actions. Async orchestration (await AuthClient, then commit) lives on
// the MemberOfferAcceptor host.
export default {
  setPhase(sm, payload) { sm.commit("phase", payload); },
  setAuthEmail(sm, payload) { sm.commit("authEmail", payload); },
  setAuthBusy(sm, payload) { sm.commit("authBusy", payload); },
  setAuthStatus(sm, payload) { sm.commit("authStatus", payload); },

  // Offer accept. Dispatching these repaints the card, exactly as the auth actions do —
  // there is no second, hand-rendered state channel.
  setEndpointStatus(sm, payload) { sm.commit("endpointStatus", payload); },
  setAcceptMessage(sm, payload) { sm.commit("acceptMessage", payload); },

  // A session exists. Dispatched on EVERY confirmed session check while signed in (the
  // host's onEveryCheck observer), not only when someone signs in — so it must tell a
  // TRANSITION (a fresh sign-in, or a switch to a different person) from a routine
  // RE-CONFIRMATION of the person already signed in.
  //
  // Identity data is always refreshed (a display name can change). But the disruptive
  // commits — yanking the visitor to the accept phase and clearing the status line — are
  // for transitions only. Re-confirming the same person must leave them exactly where they
  // are: a check can land at any moment (an accept auto-login, announceSessionChange, the
  // native re-check poke), and the Rankometer — which will clone this pattern — HAS panels
  // reachable while signed in, so an unguarded re-confirmation would throw its user out of
  // whichever one they were using.
  //
  // This is the signed-in mirror of the gating on resetAuth (see the host's
  // handleSessionState). It lives in the action so the invariant holds for every call site,
  // present and future, and travels with the action when the pattern is ported.
  signedIn(sm, person) {
    const isReconfirmation = !!sm.state.loggedIn && !!person && sm.state.person?.id === person.id;

    sm.commit("loggedIn", true);
    sm.commit("person", person || null);
    if (isReconfirmation) return;

    sm.commit("authBusy", false);
    sm.commit("phase", "accept");
    sm.commit("authStatus", null);
  },

  // Return to the logged-out accept phase, forgetting the prior address.
  resetAuth(sm) {
    sm.commit("loggedIn", false);
    sm.commit("person", null);
    sm.commit("phase", "accept");
    sm.commit("authEmail", null);
    sm.commit("authBusy", false);
    sm.commit("authStatus", null);
  },
};
